import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col, Breadcrumb as ReactstrapBreadcrumb, BreadcrumbItem } from "reactstrap";

const Breadcrumb = props => {
  const { title, breadcrumbItem } = props;
  
  return (
    <Row>
      <Col xs={12}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-0 font-size-18">{title}</h4>
          <div className="page-title-right">
            <ReactstrapBreadcrumb className="m-0">
              <BreadcrumbItem>
                <Link to="/">{title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <span>{breadcrumbItem}</span>
              </BreadcrumbItem>
            </ReactstrapBreadcrumb>
          </div>
        </div>
      </Col>
    </Row>
  );
};

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
};

export default Breadcrumb;
